import { render, staticRenderFns } from "./vAction.vue?vue&type=template&id=6141de37&scoped=true&"
import script from "./vAction.vue?vue&type=script&lang=js&"
export * from "./vAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6141de37",
  null
  
)

export default component.exports